import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';

import { RegionAbbreviations } from '../../enums/regions.js';
import { tierNumbers } from '../../enums/tiers.js';

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ColumnValue = styled.div`
  flex: ${props => props.flex ? props.flex : 1};
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.align};
  align-items: center;
  flex-wrap: wrap;
  padding: 4px;
  min-height: 2em;
  background-color: ${props => props.$hovered ? 'rgb(213, 233, 247)' : props.$rowIndex % 2 > 0 ? '#ccc' : 'white'};
  color: black;

  > a, div > a {
    color: black;
  }

  > a:hover, div > a:hover {
    color: #228fd8;
  }
`;

const StatsLinkContainer = styled.div`
  flex: 1;
  font-size: 0.85em;
`;

const TournamentRow = ({ AppStore, tournamentData, rowIndex }) => {
  const [hovered, setHovered] = useState(false);

  const cleanRegionName = tournamentData.regionName === 'EMEA'
    ? 'EMEA'
    : tournamentData.regionName.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
  const region = RegionAbbreviations[cleanRegionName]
    ? RegionAbbreviations[cleanRegionName]
    : cleanRegionName;

  const cleanTier = tournamentData.tier.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());

  useEffect(() => {
    // wat do
  }, [
    AppStore,
    tournamentData,
    rowIndex
  ]);

  return (
    <RowContainer
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ColumnValue
        key='name'
        label='name'
        align='left'
        $rowIndex={rowIndex}
        $hovered={hovered}
        flex={3}
      >
        {tournamentData.leagueName} - {tournamentData.name}
      </ColumnValue>
      <ColumnValue
        key='region'
        label='region'
        align='center'
        $rowIndex={rowIndex}
        $hovered={hovered}
      >
        {region}
      </ColumnValue>
      <ColumnValue
        key='tier'
        label='tier'
        align='center'
        $rowIndex={rowIndex}
        $hovered={hovered}
      >
        {tierNumbers[cleanTier]}
      </ColumnValue>
      <ColumnValue
        key='links'
        label='links'
        align='center'
        $rowIndex={rowIndex}
        $hovered={hovered}
      >
        <StatsLinkContainer>
          <Link to={`/stats/players/byTournament/${encodeURIComponent(tournamentData.id)}`}>
            Players
          </Link>
        </StatsLinkContainer>
        <StatsLinkContainer>
          <Link to={`/stats/teams/byTournament/${encodeURIComponent(tournamentData.id)}`}>
            Teams
          </Link>
        </StatsLinkContainer>
      </ColumnValue>
    </RowContainer>
  );
};

export default inject('AppStore')(observer(TournamentRow));